<template>
  <div>
    <!-- Mobile / Tablet -->
    <mq-layout :mq="['mobile', 'tablet']">
      <div>
        <ul id="bar" class="NavBar-Container">
          <li class="center">
            <router-link to="/" class="NavBar-Logo">
              <img src="@/assets/logo.png" max-width="100px" height="45px" />
            </router-link>
          </li>

          <!-- <div
            class="top-right-button-mobile"
            data-cy="header.language"
          >
            <language-dropdown />
          </div> -->
          <div class="rightButton"  v-if="isUserLogged">
            <div @click="$router.push({ name: 'cart' })">
              <img class="monPanierMobile" src="@/assets/icons/Mon_panier.png">
            </div>
            <div
              @click="logoutDrawer"
              class="topRightButton"
              data-cy="header.logout"
            >
              <img src="@/assets/icons/Deconnection.png">
            </div>
          </div>
        </ul>
      </div>
    </mq-layout>

    <!-- Desktop -->
    <mq-layout mq="desktop">
      <div class="top-bar-menu">
        <div class="top-right-icons">
          <!-- <div
            class="top-right-button"
            data-cy="header.language"
          >
            <language-dropdown />
          </div> -->
          <div class="top-right-button" @click="$router.push({ name: 'cart' })" v-if="isUserLogged">
            <span class="topnav-shop-badger" v-if="nbItems != 0"></span>
            <div @click="$router.push({ name: 'cart' })">
              <img class="monPanier" src="@/assets/icons/Mon_panier.png">
            </div>
            <span class="topnav-text-nav">{{ $t('menu.cart') }} <span v-if="nbItems != 0">({{ this.nbItems }})</span></span>
          </div>

          <div
            v-if="isUserLogged"
            @click="logoutDrawer"
            class="top-right-button"
            data-cy="header.logout"
          >
            <img class="logOut" src="@/assets/icons/Deconnection.png">
            <span class="topnav-text-nav1">{{ $t('global.logout') }}</span>
          </div>
          <div
            v-else
            data-cy="header.account"
            :title="$t('userAccount.myAccount')"
            v-on:click="$router.push({ name: 'userAccountPersonnalInformation' })"
            class="top-right-button"
          >
            <people-icon width="30" height="30" class="topnav-icon" />
            <span class="topnav-text">{{ $t('userAccount.myAccount') }}</span>
          </div>
        </div>
      </div>
    </mq-layout>
  </div>
</template>

<script>
import userMixin from '@/mixins/user'
import shopMixin from '@/mixins/shop'
import { OPEN_NAVIGATION_DRAWER, CLOSE_NAVIGATION_DRAWER } from '@/helpers/eventBus'
import PeopleIcon from '@/components/layout/svg/PeopleIcon'
import LogoutIcon from '@/components/layout/svg/LogoutIcon'
import ShopIcon from '@/components/layout/svg/ShopIcon'
import BurgerMenuIcon from '@/components/layout/svg/BurgerMenuIcon'
import Close from '@/components/layout/svg/Close'

import LanguageDropdown from '@/components/language/LanguageDropdown'

export default {
  name: 'Navbar',
  components: { Close, BurgerMenuIcon, PeopleIcon, LogoutIcon, ShopIcon, LanguageDropdown},
  mixins: [userMixin, shopMixin],
  data() {
    return {
      routes: [
        {
          route: '',
          label: this.$t('')
        }
      ]
    }
  },
  computed: {
    nbItems() {
      if (this.items) return this.items.length
      return 0
    }
  },
  methods: {
    openNavigationDrawer() {
      this.$eventBus.$emit(OPEN_NAVIGATION_DRAWER)
    },
    openUserAccount() {
      if (this.isUserLogged) {
        this.$router.push('/useraccount')
      } else {
        this.$router.push('/login')
      }
    },
    closeDrawer() {
      this.$eventBus.$emit(CLOSE_NAVIGATION_DRAWER)
    },
    logoutDrawer() {
      this.logout(() => {
        this.$router.push({ name: 'login' })
      })
      this.closeDrawer()
    },
  },
  mounted() {
    this.$eventBus.$on(OPEN_NAVIGATION_DRAWER, () => {
      this.isOpen = true
    })

    this.$eventBus.$on(CLOSE_NAVIGATION_DRAWER, () => {
      this.isOpen = false
    })

    if (this.$mq == 'mobile') {
      const div = document.getElementById('bar')
      let lastScroll = 0
      window.addEventListener('scroll', () => {
        if (lastScroll < window.scrollY)
          div.classList.add('scroll')
        else if (lastScroll > window.scrollY)
          div.classList.remove('scroll')
        lastScroll = window.scrollY
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';
@import '@/assets/styles/responsive.scss';
.logOut {
  margin: 3px 0px;
}
.monPanierMobile {
  position: relative;
  left: 20px;
}
.navbarMobile {
  opacity: 1;
  transition: opacity 1s, width 1s;
}
.topRightButton{
  display: flex;
  align-items: center;
}
.rightButton{
  display: flex;
  align-items: center;
  position: relative;
  left: 10px;
}
.NavBar-Container {
  display: flex;
  list-style-type: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
  background-color: white;
  height: 53px;
  width: 100%;
  box-shadow: 0 2px 7px 0 rgba(0, 0, 0, 0.14);
  justify-content: space-between;
  align-content: center;
  position: fixed;
  z-index: 100;
  top: 0;
  opacity: 1;
  transition: opacity 1s, height 0.25s;
}
.NavBar-Container.scroll {
  opacity: 0;
  height: 0;
  // display: none;
}
li {
  float: left;
}

li a {
  display: block;
  color: black;
  text-align: center;
  text-decoration: none;
  height: 53px;

  &:hover {
    cursor: pointer;
  }
}

.active {
  background-color: $primary;
  color: white;
}

.NavBar-Logo {
  padding-top: 5px;
  vertical-align: center;
  margin-left: 30px;
}

.NavBar-BurgerMenu {
  width: 53px;
}

.NavBar-Account {
  width: 53px;
}

.NavBar-Cart {
  // width: 53px;
  margin: 10px;
  display: flex;
  align-items: center;

  .topnav-shop-badger {
    width: 10px;
    height: 10px;
    background-color: $primary;
    position: absolute;
    top: 10px;
    right: 25px;
    border-radius: 50%;
  }
}

.language-right {
  margin-right: -10px;
}

.right {
  float: right;
}

.NavBar-close {
  height: 100%;
  width: 100%;
  line-height: 53px;
  text-align: center;

  & svg {
    height: 14px;
    width: 14px;
  }
}

.top-bar-menu {
  position: fixed;
  width: 100%;
  height: 50px;
  padding: 15px 50px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  background-color: #F9FAFF;
  top: 0;
  z-index: 100;
}

#logo {
  width: 90px;
}
.logo {
  flex-grow: 3;
}

.links {
  flex-grow: 2;
  & > span {
    margin: 0 35px;
    font-family: 'Helvetica', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color:#141414;
    border-bottom: 1px solid #14141400;
    transition: all 0.3s ease-in;

    @include for-size(desktop-down) {
      margin: 0 15px;
    }

    &:hover {
      border-bottom: 1px solid #141414;
    }

    & > a {
      text-decoration: none;
      color: inherit;
    }
  }
}

.top-right-button-mobile {
  margin-right: -30px;
}

.top-right-icons {
  margin-right: 100px;
  display: flex;
  cursor: pointer;
  justify-content: space-between;
  font-size: 16px;
  font-weight: 500;
  font-family: 'Helvetica', sans-serif;


  .top-right-button {
    min-width: 80px;
    height: auto;
    padding: 5px;
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    align-items: center;
    color: black;

    .topnav-text {
      margin-top: 5px;
    }
    .topnav-text-nav {
      margin-top: -20px;
    }
    .topnav-text-nav1 {
      margin-top: -16px;
    }

    .topnav-shop-badger {
      width: 10px;
      height: 10px;
      background-color: $primary;
      position: absolute;
      bottom: 55px;
      right: 298px;
      border-radius: 50%;
    } 
  }

  .top-right-button:nth-of-type(3) {
    margin-left: 15px;
  }
}

</style>
